export const LIB_VERSION = '18.1.5'; // autogenerated
//# sourceMappingURL=version.js.map